<template>
    <div v-if="fotos.length">
        <carousel
                :starting-image="0"
                :images="fotos"
                :auto-slide-interval="false"
                :show-progress-bar="false"
                v-model="imgActual"
                :dto="imgActual"
        >
            <template slot="detalle">
                <small class="text-center text-muted" >
                    {{fecha}}
                </small><br>
                {{imgActual>=0 ? lista[imgActual].dt1 : null}}
            </template>
        </carousel>
    </div>
    <div v-else class="text-center text-primary">
        No hay imágenes por el momento
    </div>
</template>

<script>
    import constantes from "../constantes";
    import carousel from "../componentes/Carousel";
    export default {
        name: "carusel",
        data:()=>({
            currentId:null,
            path:process.env.VUE_APP_URL_API,
            actual:{
                dt4:null,
                hsh1:"sinNombre",
            },
            imgActual:-1,
        }),
        components :{
            // Lingallery,
            // vGallery,
            carousel
        },
        watch:{
            imgActual:function(valor){
                this.$emit('input', this.lista[valor]);
            },
            currentId:function(valor){
                this.actual=this.lista.find(x => x.hsh1 === valor)
            }
        },
        props:{
            lista:{
                type:Array
            }
        },
        computed:{
            fecha:function(){
              return this.imgActual >=0 ? this.$moment(this.lista[this.imgActual].ddt1, "YYYY-MM-DDTHH:mm:ss").format("ddd DD MMM YYYY")  : null;
            },
            fotos:function(){
                let nuevo=[];
                // let busqueda = null;
                //nuevo.push({titulo:"Fotos",lista:[]});
                this.lista.map(item=>{
                    item.texto=`${item.dt1 ? item.dt1+' -' : ''} ${item.dt2?item.dt2:''}`;
                    // busqueda = nuevo.find(element => element.titulo ===item.dt2);
                    // if(busqueda)
                        nuevo.push(item.dt4);
                    // else
                    //     nuevo.push({titulo:item.dt2,lista:[item]});
                });
                return nuevo;
            }
        },
        methods:{
            mini:(texto)=>constantes.funciones.minusculas(texto),
            generarArchivo:(blob,nombre)=>constantes.funciones.descargar(blob,nombre),
            descargar:function(item){
                fetch(item.url)
                    .then((response) => response.blob())
                    .then((blob) => {
                        this.generarArchivo(blob, item.id);
                    });
            }
        }
    }
</script>

<style scoped>
    .sobre{
        position: absolute;
        top: 25px;
        right: 25px;
        z-index: 500;
    }
    img{
        max-height: 150px;
        height: 20%;
    }
    a{
        cursor: pointer;
    }
    .img-title{
        position: relative;
    }

</style>
